//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import Filters from './StatisticsFeesFilters.vue';
import GetReport from '~/components/GetReport.vue';
import constant from '~/const';

import tableConfig from './tableConfig';

export default {
  components: { Filters, GetReport },

  data() {
    return {
      tableConfig,
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),
    ...mapGetters('currencies', ['toCurrencyFormat', 'getP2PCurrencyByTitle']),

    ...mapState('statisticsFees', ['data', 'additionalData']),
    ...mapGetters('statisticsFees', ['requestData']),

    // todo: ask @negulus to make a new report type
    reportOperations: () => constant.reports.REPORT_TYPE_IDS.TRADES,
  },

  methods: {
    ...mapActions('common', [
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('statisticsFees', {
      loadDataAction: 'loadData',
    }),

    applyFilters() {
      this.loadDataAction();
    },
  },
};
